// extracted by mini-css-extract-plugin
export default {"wrapper":"SectionTitle_wrapper__uaFla","withOutMargin":"SectionTitle_withOutMargin__EtQSM","title":"SectionTitle_title__qqpxD","counter":"SectionTitle_counter__cT6ss"};